import { createWebHistory, createRouter } from "vue-router";

// Homepage - Keep static for fastest first load
import TemplatesAndThemes from "../components/TemplatesAndThemes/TemplatesAndThemes.vue";

// All other pages - Lazy loaded for better initial performance
const HomePageOne = () => import(/* webpackChunkName: "who-we-are" */ "../components/Pages/HomePageOne.vue");
const AppClones = () => import(/* webpackChunkName: "app-clones" */ "../components/Pages/AppClones.vue");
const MeanderLive = () => import(/* webpackChunkName: "meander-live" */ "../components/MeanderLive/MeanderLive.vue");
const MeanderOne = () => import(/* webpackChunkName: "meander-one" */ "../components/MeanderOne/MeanderOne.vue");
const DoersOnline = () => import(/* webpackChunkName: "doers-online" */ "../components/DoersOnline/DoersOnline.vue");
const DrawtopicDigital = () => import(/* webpackChunkName: "drawtopic" */ "../components/DrawtopicDigital/DrawtopicDigital.vue");
const MeanderTraining = () => import(/* webpackChunkName: "meander-training" */ "../components/MeanderTraining/MeanderTraining.vue");
const Resources = () => import(/* webpackChunkName: "resources" */ "../components/Pages/Resources.vue");
const ResourceDetails = () => import(/* webpackChunkName: "resource-details" */ "../components/Pages/ResourceDetails.vue");
const ResourceDetail = () => import(/* webpackChunkName: "resource-detail" */ "../components/Pages/ResourceDetail.vue");
const Technologies = () => import(/* webpackChunkName: "technologies" */ "../components/Pages/Technologies");
const TechnologiesClone = () => import(/* webpackChunkName: "technologies-clone" */ "../components/Pages/TechnologiesClone.vue");

const Industries = () => import(/* webpackChunkName: "industries" */ "../components/Pages/Industries");
const IndustriesClone = () => import(/* webpackChunkName: "industries-clone" */ "../components/Pages/Industry/IndustriesClone.vue");
const BlogPageThreeCustom = () => import(/* webpackChunkName: "blog-custom" */ "../components/Pages/BlogPageThreeCustom");
const AboutPageMeander = () => import(/* webpackChunkName: "about-meander" */ "../components/Pages/AboutPageMeander.vue");
const OurProcessPage = () => import(/* webpackChunkName: "our-process" */ "../components/Pages/OurProcessPage.vue");
const BecomePartnerPage = () => import(/* webpackChunkName: "become-partner" */ "../components/Pages/BecomePartnerPage.vue");
const CareerPage = () => import(/* webpackChunkName: "career" */ "../components/Pages/CareerPage.vue");
const SuccessStoriesPage = () => import(/* webpackChunkName: "success-stories" */ "../components/Pages/SuccessStory/SuccesStoriesPage.vue");
const SuccessDetailpage = () => import(/* webpackChunkName: "success-detail" */ "../components/Pages/SuccessStory/SuccessDetailpage.vue");

const HomePageTwo = () => import(/* webpackChunkName: "home-two" */ "../components/Pages/HomePageTwo");
const HomePageThree = () => import(/* webpackChunkName: "home-three" */ "../components/Pages/HomePageThree");
const HomePageFour = () => import(/* webpackChunkName: "home-four" */ "../components/Pages/HomePageFour");
const HomePageFive = () => import(/* webpackChunkName: "home-five" */ "../components/Pages/HomePageFive");
const HomePageSix = () => import(/* webpackChunkName: "home-six" */ "../components/Pages/HomePageSix");
const HomePageSeven = () => import(/* webpackChunkName: "home-seven" */ "../components/Pages/HomePageSeven");
const HomePageEight = () => import(/* webpackChunkName: "home-eight" */ "../components/Pages/HomePageEight");
const HomePageNine = () => import(/* webpackChunkName: "home-nine" */ "../components/Pages/HomePageNine");
const AboutPageOne = () => import(/* webpackChunkName: "about-one" */ "../components/Pages/AboutPageOne");
const AboutPageTwo = () => import(/* webpackChunkName: "about-two" */ "../components/Pages/AboutPageTwo");
const FeaturesPageOne = () => import(/* webpackChunkName: "features-one" */ "../components/Pages/FeaturesPageOne");
const FeaturesPageTwo = () => import(/* webpackChunkName: "features-two" */ "../components/Pages/FeaturesPageTwo");
const TeamPageOne = () => import(/* webpackChunkName: "team-one" */ "../components/Pages/TeamPageOne");
const TeamPageTwo = () => import(/* webpackChunkName: "team-two" */ "../components/Pages/TeamPageTwo");
const HowItWorksPage = () => import(/* webpackChunkName: "how-it-works" */ "../components/Pages/HowItWorksPage");
const GalleryPage = () => import(/* webpackChunkName: "gallery" */ "../components/Pages/GalleryPage");
const ServicePageClone = () => import(/* webpackChunkName: "services" */ "../components/Pages/Services/ServicePageClone.vue");
const PricingPage = () => import(/* webpackChunkName: "pricing" */ "../components/Pages/PricingPage");
const PaymentConfirmationPage = () => import(/* webpackChunkName: "payment-confirmation" */ "../components/Pages/PaymentConfirmationPage.vue");
const FeedbackPage = () => import(/* webpackChunkName: "feedback" */ "../components/Pages/FeedbackPage");
const SignInPage = () => import(/* webpackChunkName: "auth" */ "../components/Pages/SignInPage");
const SignUpPage = () => import(/* webpackChunkName: "auth" */ "../components/Pages/SignUpPage");
const ForgetPasswordPage = () => import(/* webpackChunkName: "auth" */ "../components/Pages/ForgetPasswordPage");
const PrivacyPolicyPage = () => import(/* webpackChunkName: "legal" */ "../components/Pages/PrivacyPolicyPage");
const ReturnPolicyPage = () => import(/* webpackChunkName: "legal" */ "../components/Pages/ReturnPolicyPage");
const ShippingPolicyPage = () => import(/* webpackChunkName: "legal" */ "../components/Pages/ShippingPolicyPage");
const TermsConditionsPage = () => import(/* webpackChunkName: "legal" */ "../components/Pages/TermsConditionsPage");
const ScreenshotsPage = () => import(/* webpackChunkName: "screenshots" */ "../components/Pages/ScreenshotsPage");
const FaqPage = () => import(/* webpackChunkName: "faq" */ "../components/Pages/FaqPage");
const ComingSoonPage = () => import(/* webpackChunkName: "coming-soon" */ "../components/Pages/ComingSoonPage");
const ErrorPage = () => import(/* webpackChunkName: "error" */ "../components/Pages/ErrorPage");
const AppDownloadPage = () => import(/* webpackChunkName: "app-download" */ "../components/Pages/AppDownloadPage");
const BlogPageOne = () => import(/* webpackChunkName: "blog" */ "../components/Pages/BlogPageOne");
const BlogPageTwo = () => import(/* webpackChunkName: "blog" */ "../components/Pages/BlogPageTwo");
const BlogDetailsPage = () => import(/* webpackChunkName: "blog-details" */ "../components/Pages/BlogDetailsPage");
const ContactPage = () => import(/* webpackChunkName: "contact" */ "../components/Pages/ContactPage");
const AppDetail = () => import(/* webpackChunkName: "app-detail" */ "../components/Pages/AppDetail.vue");
const BuildWithMeander = () => import(/* webpackChunkName: "build-with-meander" */ "../components/Pages/BuildWithMeander.vue");
const WebinarPage = () => import(/* webpackChunkName: "webinar" */ "../components/Pages/WebinarPageImproved.vue");
const ProductGrowWithMeander = () => import(/* webpackChunkName: "product-grow-with-meander" */ "../components/Pages/ProductGrowWithMeander.vue");


export const routes = [
  { path: "/", component: TemplatesAndThemes },
  { path: "/projects", component: TemplatesAndThemes },

  { path: "/who-we-are", component: HomePageOne },
  { path: "/app-clones/:slug", name: 'app-clones', component: AppClones },

  { path: "/project/:slug", name: 'project', component: AppDetail },

  // Redirect from old /app-detail/:slug to /project/:slug
  { path: "/app-detail/:slug", redirect: to => `/project/${to.params.slug}` },

  { path: "/technologies/:slug", name: 'technologies', component: TechnologiesClone },
  { path: "/industries/:slug", name: 'industries', component: IndustriesClone },
  { path: "/services/:slug", name: 'services', component: ServicePageClone },



  // Redirects from old /products/ paths to new /project/ paths
  { path: "/products/meander-live", redirect: "/project/meander-live" },
  { path: "/products/meander-one", redirect: "/project/meander-one" },
  { path: "/products/doers-online", redirect: "/project/doers-online" },
  { path: "/products/draw-topic-digital", redirect: "/project/draw-topic-digital" },
  { path: "/products/meander-training", redirect: "/project/meander-training" },


  { path: "/resource-details/:slug", component: ResourceDetails },
  { path: "/resource-detail/:slug", component: ResourceDetail },
  { path: "/resources", component: Resources },
  { path: "/technologies", component: Technologies },
  { path: "/industries", component: Industries },
  { path: "/blog-custom", component: BlogPageThreeCustom },
  { path: "/about-meander", component: AboutPageMeander },
  { path: "/our-process", component: OurProcessPage },
  { path: "/become-a-partner", component: BecomePartnerPage },
  { path: "/career", component: CareerPage },
  { path: "/success-stories", component: SuccessStoriesPage },
  { path: "/success-detail/:slug", component: SuccessDetailpage },
  { path: "/home-two", component: HomePageTwo },
  { path: "/home-three", component: HomePageThree },
  { path: "/home-four", component: HomePageFour },
  { path: "/home-five", component: HomePageFive },
  { path: "/home-six", component: HomePageSix },
  { path: "/home-seven", component: HomePageSeven },
  { path: "/home-eight", component: HomePageEight },
  { path: "/home-nine", component: HomePageNine },
  { path: "/about-simple", component: AboutPageOne },
  { path: "/about-modern", component: AboutPageTwo },
  { path: "/features-one", component: FeaturesPageOne },
  { path: "/features-two", component: FeaturesPageTwo },
  { path: "/team-one", component: TeamPageOne },
  { path: "/team-two", component: TeamPageTwo },
  { path: "/how-it-works", component: HowItWorksPage },
  { path: "/gallery", component: GalleryPage },
  { path: "/pricing", component: PricingPage },
  { path: "/payment-confirmation", name: 'payment-confirmation', component: PaymentConfirmationPage },
  { path: "/feedback", component: FeedbackPage },
  { path: "/sign-in", component: SignInPage },
  { path: "/sign-up", component: SignUpPage },
  { path: "/forget-password", component: ForgetPasswordPage },
  { path: "/privacy-policy", component: PrivacyPolicyPage },
  { path: "/return-policy", component: ReturnPolicyPage },
  { path: "/shipping-policy", component: ShippingPolicyPage },
  { path: "/terms-conditions", component: TermsConditionsPage },
  { path: "/screenshots", component: ScreenshotsPage },
  { path: "/faq", component: FaqPage },
  { path: "/coming-soon", component: ComingSoonPage },
  { path: "/error", component: ErrorPage },
  { path: "/app-download", component: AppDownloadPage },
  { path: "/blog-grid", component: BlogPageOne },
  { path: "/blog-right-sidebar", component: BlogPageTwo },
  { path: "/contact", component: ContactPage },
  { path: "/grow-with-meander", component: ProductGrowWithMeander },
  { path: "/build-with-meander", component: WebinarPage },
  { path: "/project/grow-with-meander", redirect: "/grow-with-meander" },

  // Direct Standalone Package Route
  { path: "/package/:slug", name: 'package-details', component: () => import("../components/Pages/PackageDetails.vue") },

  // 404 Catch-all route - must be at the end
  { path: "/:pathMatch(.*)*", name: 'NotFound', component: ErrorPage },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If navigating back/forward, use saved position
    if (savedPosition) {
      return savedPosition;
    }
    // If only query parameters changed (like page number) on the same path, scroll to top
    if (to.path === from.path) {
      // Check if page query parameter changed
      const toPage = to.query.page;
      const fromPage = from.query.page;

      // If page parameter changed, scroll to top
      if (toPage !== fromPage) {
        return { top: 0, behavior: 'smooth' };
      }

      // Check if other query parameters changed
      const otherQueryChanged = Object.keys(to.query).some(key =>
        key !== 'page' && to.query[key] !== from.query[key]
      ) || Object.keys(from.query).some(key =>
        key !== 'page' && !(key in to.query)
      );

      // If other query parameters changed, scroll to top
      if (otherQueryChanged) {
        return { top: 0, behavior: 'smooth' };
      }

      // If no significant query changes, preserve scroll position
      return false;
    }
    // For path changes, scroll to top
    return { top: 0, behavior: 'smooth' };
  },
});

// Handle chunk loading errors (e.g., when a new deployment invalidates old chunks)
// This catches the "Unexpected token '<'" error from HTML files served instead of JS
router.onError((error, to) => {
  const errorMsg = error.message || '';
  const isChunkLoadFailed = error.name === 'ChunkLoadError' 
    || errorMsg.includes('Failed to fetch dynamically imported module') 
    || errorMsg.includes('Importing a module script failed')
    || errorMsg.includes('Unexpected token')
    || errorMsg.includes('Unexpected identifier');
  
  if (isChunkLoadFailed) {
    const reloadKey = `chunk_reload_${to.fullPath}`;
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, 'true');
      console.warn(`Chunk load error detected for ${to.fullPath}. Reloading page...`);
      window.location.reload();
    } else {
      console.error('Failed to load chunk even after reloading:', error);
      setTimeout(() => sessionStorage.removeItem(reloadKey), 10000);
    }
  }
});

export default router;
